import React from 'react';
import type { MouseEvent, ReactNode } from 'react';
type Variant = 'primary' | 'secondary' | 'outlineLight';
type Size = 'md' | 'lg';
interface ButtonLinkProps {
  href: string;
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  external?: boolean;
  icon?: ReactNode;
  className?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}
const variantClasses: Record<Variant, string> = {
  primary: 'bg-brand text-white hover:bg-brand-dark',
  secondary: 'border-2 border-ink text-ink hover:bg-ink hover:text-white',
  outlineLight: 'border-2 border-white/40 text-white hover:border-white hover:bg-white hover:text-ink'
};
const sizeClasses: Record<Size, string> = {
  md: 'min-h-[44px] px-5 text-[15px]',
  lg: 'min-h-[52px] px-7 text-base'
};
export function ButtonLink({
  href,
  children,
  variant = 'primary',
  size = 'lg',
  external = false,
  icon,
  className = '',
  onClick
}: ButtonLinkProps) {
  return <a href={href} onClick={onClick} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded font-semibold transition-[background-color,color,border-color,transform] duration-150 ease-out active:scale-[0.98] ${variantClasses[variant]} ${sizeClasses[size]} ${className}`} data-id="element-473" data-mp="3i1wo67089yz2">
      {children}
      {icon}
      {external && <span className="sr-only" data-id="element-474" data-mp="24r37wb8bqigv"> (opens in a new tab)</span>}
    </a>;
}